import { PrincipalSchema, type Principal } from '@ampshift/shared';
import { setAuthState } from './store';

const PartialPrincipal = PrincipalSchema.partial({ sessionId: true });

/** `GET /dev/principals` — only served by the local dev API when AMPSHIFT_DEV_AUTH=1. */
export async function fetchDevPrincipals(base = import.meta.env.VITE_API_BASE ?? ''): Promise<Record<string, Principal>> {
  const res = await fetch(`${base}/dev/principals`, { headers: { Accept: 'application/json' } });
  if (!res.ok) throw new Error(`Dev principals unavailable (${res.status}). Is the API running with AMPSHIFT_DEV_AUTH=1?`);
  const raw: unknown = await res.json();
  if (!raw || typeof raw !== 'object') throw new Error('Dev principals: unexpected payload');
  // The dev API serves `{ principals: {...}, tenantId, llm }`; older shapes were a flat map.
  const obj = raw as Record<string, unknown>;
  const map = (obj['principals'] && typeof obj['principals'] === 'object' ? obj['principals'] : obj) as Record<string, unknown>;
  const out: Record<string, Principal> = {};
  for (const [key, value] of Object.entries(map)) {
    const parsed = PartialPrincipal.safeParse(value);
    if (!parsed.success) continue; // skip metadata keys such as tenantId / llm
    out[key] = { ...parsed.data, sessionId: parsed.data.sessionId ?? 'tab' };
  }
  if (Object.keys(out).length === 0) throw new Error('Dev principals: no principals in payload');
  return out;
}

export function signInAsDevPrincipal(principal: Principal): void {
  setAuthState({ status: 'dev', principal });
}
